export enum LocationType {
  RESIDENTIAL,
  DEALERSHIP,
  AUCTION,
  PORT,
}
